import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import { router } from "../router/index";
import {
  setLocalStorage,
  clearLocalStorage,
  setLocalStorageNewTokenKey,
  setLocalStorageExpiredStatus,
} from "../js/oauth";
import { setSnackBarInfo } from "../js/common_function";

const AXIOS = axios.create({
  baseURL: "/api",
  timeout: 10000,
});

const state = {
  // status: "",
};

const getters = {
  // status(state) {
  //   return state.status;
  // },
};

const mutations = {
  // SET_INFO(state, detailInfo) {
  //   state.status = detailInfo.status;
  //   state.token = detailInfo.token;
  //   state.info = detailInfo.info;
  // },
};

function deleteRow(member) {
  return AXIOS({
    url: "/toDoApp/deleteRow",
    method: "post",
    data: {
      id: member.id,
    },
    headers: {
      "token-key": localStorage.getItem("token-key"),
    },
  });
}
function updateRow(member) {
  return AXIOS({
    url: "/toDoApp/updateRow",
    method: "post",
    data: {
      id: member.id,
      title: member.title,
      done: member.done,
    },
    headers: {
      "token-key": localStorage.getItem("token-key"),
    },
  });
}
function allUpdateRow(results) {
  return AXIOS({
    url: "/toDoApp/allUpdateRow",
    method: "post",
    data: {
      results: results,
    },
    headers: {
      "token-key": localStorage.getItem("token-key"),
    },
  });
}
function allRowDelete(selected) {
  return AXIOS({
    url: "/toDoApp/allRowDelete",
    method: "post",
    data: {
      selected: selected,
    },
    headers: {
      "token-key": localStorage.getItem("token-key"),
    },
  });
}

const actions = {
  async DELETE_ROW(context, member) {
    try {
      const response = await deleteRow(member);
      context.commit("SET_SNACKBAR", setSnackBarInfo("삭제 되었습니다."));
      return response;
    } catch (e) {
      console.log(e);
      context.commit("SET_SNACKBAR", setSnackBarInfo("삭제 실패."));
    }
  },
  async UPDATE_ROW(context, member) {
    try {
      const response = await updateRow(member);
      context.commit("SET_SNACKBAR", setSnackBarInfo("수정 되었습니다."));
      return response;
    } catch (e) {
      console.log(e);
      context.commit("SET_SNACKBAR", setSnackBarInfo("수정 실패."));
    }
  },
  async ALL_UPDATE_ROW(context, results) {
    try {
      const response = await allUpdateRow(results);
      context.commit("SET_SNACKBAR", setSnackBarInfo("수정 되었습니다."));
      return response;
    } catch (e) {
      console.log(e);
      context.commit("SET_SNACKBAR", setSnackBarInfo("수정 실패."));
    }
  },
  async ALL_ROW_DELETE(context, selected) {
    try {
      const response = await allRowDelete(selected);
      context.commit(
        "SET_SNACKBAR",
        setSnackBarInfo("선택 항목 삭제 되었습니다.")
      );
      return response;
    } catch (e) {
      console.log(e);
      context.commit("SET_SNACKBAR", setSnackBarInfo("수정 실패."));
    }
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
